import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import MainSearchInputClient from './MainSearchInputClient';
export default function MainSearchInput() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={<div className="flex w-[400px] items-center rounded-lg bg-colorBg09 pl-4"><div className="h-[40px] w-full" /><div className="flex h-[40px] w-[40px] items-center justify-center" /></div>}><MainSearchInputClient /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}